/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * Animation for closing Alert:
 * Alert's contents slide up off-screen, and
 * Alert's height goes to zero.
 * Must be animated in JavaScript because how far to slide up (height) must be calculated at run-time.
 */
angular.module('bulbApp.animationModule')
.animation('.bulb-alert', function() {
  var ANIMATION_DURATION = 300;
  return {
    leave: function(element, done) {
      var height = element.outerHeight();
      // All contents of alert must have position: relative.
      var contents = element.find('.close-control,.bulb-alert-message');
      // slide contents up
      contents.stop().animate({
        top: '-' + height + 'px'
      }, ANIMATION_DURATION);
      // close alert
      element.stop().slideUp(ANIMATION_DURATION, done);
    }
  };
});
